import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { desktop, tablet } from '../../../../designSystem/BreakPoints';
import { colors } from '../../../../designSystem/colors/color';
import { Label } from '../../../../designSystem/Label';

type FooterProps = {
    siteId?:string,
    publicSupportUrl?:boolean
}
export const Footer = ({siteId, publicSupportUrl}: FooterProps): JSX.Element => {
    return (
        <Wrapper>
        <FooterContainer className="footer">
            
            <LogoContainer>
                <img src="/images/amorg_logo_blue.svg" />
            </LogoContainer>


            <SiteId>
                <Label>
                    {siteId || ''}
                </Label>
            </SiteId>
            
            <Info>
                © 2022 AMORG ApS | CVR: 43511750
            </Info>
            <FooterNav>
                <ul>
                    <li><NavLink to={publicSupportUrl ? "https://amorg.dk/support" : "/support"} className={({ isActive }) => isActive ? 'active' : undefined}>Kontakt & Support</NavLink></li>
                </ul>
                <ul>
                    <li><NavLink to={publicSupportUrl ? "https://amorg.dk/privacypolicy" : "/privacy"} className={({ isActive }) => isActive ? 'active' : undefined}>Privatlivspolitik</NavLink></li>
                </ul>
            </FooterNav>
                
            
        </FooterContainer>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width:100%;
    grid-area: footer;
    margin-top: 32px;
`;

const FooterContainer = styled.div`
    
    max-width: 90%;
    margin: 0 auto;
    align-self: end;
    color: ${colors.text.normal};
    

    border-top: 1px solid rgb(88, 88, 88);
    padding: 1rem 0;
    width: 100%;
    z-index: 1;
    box-sizing: border-box;

    display: grid;
    
    grid-template-areas: "logo siteid info footernavigation";

    grid-template-columns: min-content min-content 1fr min-content;
    grid-template-rows: auto;

    @media (max-width: ${tablet}px) {
        grid-template-columns: min-content 1fr;
        grid-template-areas: 
            "logo footernavigation"
            "logo info";
        height: auto;
        width: 100vw;
        box-sizing: border-box;
    }
`;


const LogoContainer = styled.span`
    display: block;
    grid-area: logo;
    margin-left: 0px;
    height: 32px;
    width: 32px;
    align-self: end;

`;

const SiteId = styled.span`
    
    display:none;
    

    @media (min-width: ${desktop}px) {
        grid-area: siteid;
        display:flex;
        flex-direction: column;
        align-self: center;
        white-space: nowrap;
        margin-left: 8px;
    }

`;

const Info = styled.span`
    align-self: center;
    grid-area: info;
    justify-self: center;
    font-size: 0.8rem;

    @media(min-width: ${tablet}px){
        
    }
`

const FooterNav = styled.div`
    align-self: flex-start;
    display: flex;
    grid-area: footernavigation;

    & ul{
        list-style-type: none;
        margin-bottom: 0;
        margin-top: 0;

        & li{
            text-align:right;
            margin-bottom: 5px;
            white-space: nowrap;

        }
    }

    & a{
        color:${colors.link.footer.normal};
        text-decoration: none;
        transition: color .2s ease;
        font-size: 11px;
        font-weight: 600;

        &:hover{
            color: ${colors.link.footer.hover};
        }
    }

    @media(min-width: ${desktop}px){
        flex-direction: row;
        align-self: center;
        
    }

`;